module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-41-6041c995bf071195a5dc70a8d6b5b28e.svg";